import { render } from "./DevTool.vue?vue&type=template&id=174752c6&scoped=true&ts=true"
import script from "./DevTool.vue?vue&type=script&lang=ts"
export * from "./DevTool.vue?vue&type=script&lang=ts"

import "./DevTool.vue?vue&type=style&index=0&id=174752c6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174752c6"]])

export default __exports__